export default "//yastatic.net/s3/distribution/pythia/frontend/_/fb2f8775e7bb2862b3ec2c13cb5b12ee.svg";